import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-offertiminglayout',
  templateUrl: './offertiminglayout.component.html',
  styleUrls: ['./offertiminglayout.component.scss']
})
export class OffertiminglayoutComponent implements OnInit, OnDestroy {

  @Input() item: any;

  @Input() img: any;

  @Input() data: any;

startDays: string = '00';
  startHours: string = '00';
  startMinutes: string = '00';
  startSeconds: string = '00';

  endDays: string = '00';
  endHours: string = '00';
  endMinutes: string = '00';
  endSeconds: string = '00';

  isOfferActive: boolean = false;
  isCountdownVisible: boolean = true;

  // Custom date/time fields
  customField9: any; // Start Date
  customField10: any;     // Start Time
  customField11: any; // End Date
  customField12: any ;     // End Time

  offerStartDate!: Date;
  offerEndDate!: Date;

  formattedOfferStart: string = '';
  formattedOfferEnd: string = '';

  private intervalId: any;

  ngOnInit(): void {

    this.customField9=this.item.customField9; // Start Date
    this.customField10=this.item.customField10;
    this.customField11=this.item.customField11;
    this.customField12=this.item.customField12;
    this.initializeOfferDates();
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private initializeOfferDates(): void {
    const startString = `${this.customField10}`;
    const endString = `${this.customField11}`;

    this.offerStartDate = new Date(startString);
    this.offerEndDate = new Date(endString);

    this.formattedOfferStart = this.formatDateTime(this.offerStartDate);
    this.formattedOfferEnd = this.formatDateTime(this.offerEndDate);
  }

  private formatDateTime(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      // hour: '2-digit',
      // minute: '2-digit',
      // hour12: true
    };
    return date.toLocaleString('en-US', options);
  }

  private startCountdown(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => this.updateCountdowns(), 1000);
  }

  private updateCountdowns(): void {
    const now = new Date().getTime();
    const startDistance = this.offerStartDate.getTime() - now;
    const endDistance = this.offerEndDate.getTime() - now;

    if (startDistance > 0) {
      this.setFormattedTime(startDistance, 'start');
    } else {
      this.isCountdownVisible = false;
      this.isOfferActive = true;
    }

    if (endDistance > 0) {
      this.setFormattedTime(endDistance, 'end');
    } else {
      this.isOfferActive = false;
      clearInterval(this.intervalId);
    }
  }

  private setFormattedTime(distance: number, type: 'start' | 'end'): void {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const formattedDays = days < 10 ? `0${days}` : `${days}`;
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    if (type === 'start') {
      this.startDays = formattedDays;
      this.startHours = formattedHours;
      this.startMinutes = formattedMinutes;
      this.startSeconds = formattedSeconds;
    } else {
      this.endDays = formattedDays;
      this.endHours = formattedHours;
      this.endMinutes = formattedMinutes;
      this.endSeconds = formattedSeconds;
    }
  }


}
